import instance from './common';

export const getSPIThresholds = (reqBody, options = {}, http = instance) =>
  http.get('/spi/kpi', reqBody);
export const updateCustomKPI = (reqBody, options = {}, http = instance) =>
  http.put('/spi/kpi', reqBody, options);
export const deleteCustomKPI = (reqBody, options = {}, http = instance) =>
  http.delete(`/spi/kpi/${reqBody.kpiId}`, reqBody);
export const getSelectedKPI = (reqBody, options = {}, http = instance) =>
  http.get('/spi/user/kpi', reqBody);
export const saveSelectedKPI = (reqBody, options = {}, http = instance) =>
  http.post('/spi/user/kpi', reqBody, options);
export const saveAndApplySelectedKPI = (reqBody, options = {}, http = instance) =>
  http.post('/spi/kpi/save-and-apply', reqBody, options);
export const getKpiMetaConfigs = (reqBody, options = {}, http = instance) =>
  http.get('/spi/kpi/meta-configs', reqBody);

export default getSPIThresholds;
